export default {
  // 對話框標題
  dialogTitle: "添加模型驗證地址",

  // 表單標籤
  modelType: "模型類型:",
  blockchain: "公鏈:",
  caseName: "案件名稱:",
  address: "地址:",

  // 佔位符
  selectModelType: "請選擇模型類型",
  selectBlockchain: "請選擇公鏈",
  selectCaseName: "請選擇案件名稱",
  inputAddress: "請輸入地址",

  // 模型類型
  firstFeeFeeModel: "首筆手續費模型",
  relatedFeeModel: "關聯手續費模型",
  tornadoModel: "龍捲風模型",

  // 按鈕
  reset: "重置",
  add: "添加",

  // 警告提示
  warningInfo:
    "支持批量地址驗證，批量地址輸入格式請注意，地址與地址之間增加空格或者折行",

  // 表單驗證
  inputAddressRequired: "請輸入地址",
  selectModelTypeRequired: "請選擇模型類型",
  selectBlockchainRequired: "請選擇公鏈",
  selectCaseNameRequired: "請選擇案件名稱",

  // 消息提示
  professionalFeature: "當前功能僅專業版用戶可用，請聯繫客服諮詢。",
  submitSuccess: "提交成功請等待結果",
  addModelSuccess: "添加模型驗證成功",
  tip: "提示",
  confirm: "確定",
  cancel: "取消",
};
